import moment from "moment"

export const formatDate = (date: string | undefined): string | null => {
  if (date) {
    const mDate = moment(date)

    if(mDate.isValid()) {
      return mDate.format("DD. MM. YYYY")
    }
  }

  return null
}

export const formatPayloadDate = (date: Date | undefined): string => {
  if (date) {
    return moment(date).format("YYYY-MM-DD")
  }

  return ""
}

export const parseDate = (date: string | null | undefined): Date | undefined => {
  if (date) {
    return moment(date).toDate()
  }

  return undefined
}
